import axios from '../index';

export const requestPractitioners = async () => {
  const getAllPractitioners = async (prev, query) => {
    const currentList = await axios.get(
      `${query ? `/fhir/?${query}` : '/fhir/Practitioner?_count=250'}`,
    );
    const nextLink = currentList.data.link.find(({ relation }) => relation === 'next');
    const prevEntry = (prev && prev.data && prev.data.entry) || [];
    const currentEntry = currentList.data.entry;
    currentList.data.entry = prevEntry.concat(currentEntry);

    if (nextLink) {
      const nextQuery = nextLink.url.split('?')[1];
      return getAllPractitioners(currentList, nextQuery);
    }

    return currentList;
  };
  const allPractitioners = await getAllPractitioners();
  return allPractitioners;
};

export const requestPractitionersGetByLogin = ({ username }) =>
  axios.get(`/json-admin/user-management?searchTerm=${username}`);

export const requestPractitionersCreate = ({ data }) => axios.post('/user-management', data);
